export default {
  'pendingDecisionsGrid.decisionChange': 'Decision Change',
  'pendingDecisionsGrid.ACCEPT': 'Accept',
  'pendingDecisionsGrid.DEBIT': 'Debit',
  'pendingDecisionsGrid.CREDIT': 'Credit',
  'pendingDecisionsGrid.PAY_AND_ADD_RULE': 'Pay and Add Rule',
  'pendingDecisionsGrid.RETURN': 'Return',
  'pendingDecisionsGrid.RETURN_AND_ADD_RULE': 'Return and Add Rule',
  'pendingDecisionsGrid.PAY': 'Pay',
  'pendingDecisionsGrid.viewRule': 'View Rule',
  'pendingDecisionsGrid.NEEDS_DECISION': 'Needs Decision',
  'pendingDecisionsGrid.NEEDS_DECISION_ROLLBACK': 'Needs Decision',
  'pendingDecisionsGrid.NEEDS_DECISION_PARTIAL_MATCH': 'Needs Decision',
  'pendingDecisionsGrid.CUTOFF_PAY': 'Default/Pay',
  'pendingDecisionsGrid.CUTOFF_RETURN': 'Default/Return',
  'pendingDecisionsGrid.AUTOPAY': 'Rule Applied/Pay',
  'pendingDecisionsGrid.AUTORETURN': 'Rule Applied/Return',
  'pendingDecisionsGrid.returnAndAddaRule': 'Return and add a rule',
  'pendingDecisionsGrid.exceptionDecisions': 'Exception Decisions',
  'pendingDecisionsGrid.decisionDate': 'Decision Date',
  'pendingDecisionsGrid.accountName': 'Account Name',
  'pendingDecisionsGrid.ruleType': 'Rule Type',
  'pendingDecisionsGrid.changedOn': 'Changed On',
  'pendingDecisionsGrid.changedBy': 'Changed By',
  'pendingDecisionsGrid.reason': 'Reason',
  'pendingDecisionsGrid.accounts': 'Accounts',
  'pendingDecisionsGrid.accountNickname': 'Account Nickname',
  'pendingDecisionsGrid.accountNumber': 'Account Number',
  'pendingDecisionsGrid.originatorId': 'Originator ID',
  'pendingDecisionsGrid.originatorName': 'Originator Name',
  'pendingDecisionsGrid.amount': 'Amount',
  'pendingDecisionsGrid.maxAmount': 'Max Amount',
  'pendingDecisionsGrid.minAmount': 'Min Amount',
  'pendingDecisionsGrid.entryDescription': 'Entry Description',
  'pendingDecisionsGrid.effectiveDate': 'Effective Date',
  'pendingDecisionsGrid.originalRuleModified': 'Original Rule Modified',
  'pendingDecisionsGrid.cannotBeApplied': 'Existing Rule cannot be applied',
  'pendingDecisionsGrid.returnReason': 'Return Reason',
  'pendingDecisionsGrid.enteredBy': 'Entered By',
  'pendingDecisionsGrid.cutoffNonBusinessDayMsg':
    'Exceptions will not be processed on holiday or non-business day',
  'pendingDecisionsGrid.achPosPayIsDisabled':
    'Transactions pending decision for account{0} {1} are not displayed due to an insufficient account balance. Please contact Customer Service for assistance.',
  'pendingDecisionsGrid.alert.success.PAY': 'Pay decision applied successfully',
  'pendingDecisionsGrid.alert.success.RETURN': 'Return decision applied successfully',
  'pendingDecisionsGrid.alert.confirmChanges':
    'Decision <%=currentDecision%> has been applied by <%=userName%> on <%=decisionDate%>. Do you want to change decision to <%=changeToDecision%>?'
};
